import styled from 'styled-components'

export const CaptionWrapper = styled.div`
	margin: 4px 0 -4px 32px;
	opacity: 0.5;
`
